//#region Imports
import { Stack } from '@mui/material';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import { GlobalVariables } from '../../../globalVar';
import { useTableLocale } from '../../../hooks/useTableLocale';
import usePersistedColumnOrder from '../../../hooks/UseCustomColumnOrder';
//#endregion

const LOCAL_COLUMN_WIDTH = GlobalVariables.getDefaultColumnWidth();

export const SurveysTable = ({ data, isFetching, fetchData }) => {
  console.log('🚀 ~ survey data:', data);

  const locale = useTableLocale();

  // Filter out rows with question 'Firma' (case-insensitive, trimmed)
  const filteredRows = Array.isArray(data)
    ? data.filter((r) => {
        const q = (r?.question_text || '').toString().trim().toLowerCase();
        return q !== 'firma';
      })
    : [];

  // Define initial table columns for survey data
  const initialColumns = [
    {
      field: 'id',
      headerName: 'ID',
      headerAlign: 'center',
      align: 'center',
      type: 'number',
      width: LOCAL_COLUMN_WIDTH * 0.5,
      hide: true,
      filterable: true,
    },
    {
      field: 'question_text',
      headerName: 'Pregunta',
      type: 'string',
      width: LOCAL_COLUMN_WIDTH * 3.7,
      filterable: true,
      renderCell: (params) => params.row.question_text || '-',
    },
    {
      field: 'answer_str',
      headerName: 'Respuesta',
      type: 'string',
      width: LOCAL_COLUMN_WIDTH,
      filterable: true,
      renderCell: (params) => params.row.answer_str ?? '-',
    },
    {
      field: 'visit_id',
      headerName: 'Visita ID',
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      width: LOCAL_COLUMN_WIDTH,
      filterable: true,
      // Display visit_id without commas (e.g., '1,234' -> '1234')
      valueFormatter: (params) => {
        if (params.value == null) return '';
        // Convert value to string and remove commas
        return params.value.toString().replace(/,/g, '');
      },
    },
  ];

  // No action column — table is read-only for survey responses

  const [columns, updateColumnOrder] = usePersistedColumnOrder(
    'surveysTable',
    initialColumns
  );

  /**
   * Handles column order changes for the table.
   * @param {Object} params - Parameters containing target and old index.
   */
  const handleColumnOrderChange = (params) => {
    const { targetIndex, oldIndex } = params;

    const updatedColumns = [...columns];
    const [movedColumn] = updatedColumns.splice(oldIndex, 1);
    updatedColumns.splice(targetIndex, 0, movedColumn);

    updateColumnOrder(updatedColumns); // Update column order in persisted state
  };

  return (
    <>
      {/* Header and Add Button */}
      <div className='datatable-btns-container'>
        <div className='dt-btn-main-container'>
          <span className='dabiWebText'>Encuestas</span>
        </div>
      </div>

      <DataGridPro
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
        rows={filteredRows}
        columns={columns}
        loading={isFetching}
        onColumnOrderChange={(params) => handleColumnOrderChange(params)}
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'asc' }],
          },
          // no pinned action column
        }}
        slots={{
          noRowsOverlay: () => (
            <Stack height='100%' alignItems='center' justifyContent='center'>
              No hay encuestas en la base de datos
            </Stack>
          ),
          toolbar: GridToolbar, // Toolbar with default functionality
        }}
      />
    </>
  );
};
